<div class="maintenance-timeline-item" [class.maintenance-timeline-item--completed]="item.isCompleted" *transloco="let t; prefix: 'assetOverview.timeline'">
    
  <!-- left Section -->
  <div class="maintenance-timeline-item-main">
    <div class="maintenance-timeline-item-wo">
      {{ item.workOrderNumber }}
    </div>

    <div class="maintenance-timeline-item-meta-row">
      <div>
        <span class="maintenance-timeline-item-meta-label">{{ t('interval') }}</span>
        <span class="maintenance-timeline-item-meta-value">
          {{ item.serviceInterval }}
        </span>
      </div>
      
      <div>
        <span class="maintenance-timeline-item-meta-label">{{ t('serviceType') }}</span>
        <span class="maintenance-timeline-item-meta-value">
          {{ item.serviceTypeLabel }}
        </span>
      </div>
    </div>

    <div class="maintenance-timeline-item-parts-row">
      <span class="maintenance-timeline-item-parts-label">{{ item.isCompleted ? t('partsUsed') : t('partsRequired') }}</span>

      @if (!item.partsUsed.length) {
        <app-inline-empty-state [message]="t('noParts')"></app-inline-empty-state>
      } @else {
        <div class="maintenance-timeline-item-parts-chips-scroll">
        @if(showLeftArrow) {
          <button type="button" class="maintenance-timeline-item-parts-chips-arrow maintenance-timeline-item-parts-chips-arrow--left" [attr.aria-label]="t('scrollLeft')"
            (click)="scrollChips(-1); $event.stopPropagation()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.86202 4.19531L5.05739 7.99998L8.86202 11.8046L9.80469 10.862L6.94269 7.99998L9.80469 5.13798L8.86202 4.19531Z" fill="#9FA1A4"/>
            </svg>                   
          </button>
        }
        <div class="maintenance-timeline-item-parts-chips" #chipsScroller (scroll)="onChipsScroll($event)">
          @for(part of item.partsUsed; track part) {
            <span class="maintenance-timeline-item-parts-chip">
              {{ part }}
            </span>
          }
        </div>
        @if(showRightArrow) {
          <button type="button" class="maintenance-timeline-item-parts-chips-arrow maintenance-timeline-item-parts-chips-arrow--right" [attr.aria-label]="t('scrollRight')"
            (click)="scrollChips(1); $event.stopPropagation()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.13798 11.8046L10.9426 7.99998L7.13798 4.19531L6.19531 5.13798L9.05731 7.99998L6.19531 10.862L7.13798 11.8046Z" fill="#9FA1A4"/>
            </svg>                    
          </button>
        }
        </div>
      }
    </div>
  </div>

  <!-- Middle Section -->
  <div class="maintenance-timeline-item-stats">
    <div class="maintenance-timeline-item-stats-stat">
      <div class="maintenance-timeline-item-stats-stat-label">{{ t('cost') }}</div>
      <div class="maintenance-timeline-item-stats-stat-value">
        {{ item.costLabel }}
        @if (item.costTooltip) {
          <span class="maintenance-timeline-item-stats-stat-info" [ngbTooltip]="item.costTooltip" container="body">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM7.33333 10H6V6H7.33333V10ZM7.33333 4.66667H6V3.33333H7.33333V4.66667Z" fill="#9FA1A4"/>
            </svg>
          </span>
        }
      </div>
    </div>

    <div class="maintenance-timeline-item-stats-stat">
      <div class="maintenance-timeline-item-stats-stat-label">{{ t('workshop') }}</div>
      <div class="maintenance-timeline-item-stats-stat-value">{{ item.workshop }}</div>
    </div>

    <div class="maintenance-timeline-item-stats-stat">
      <div class="maintenance-timeline-item-stats-stat-label">{{ t('technician') }}</div>
      <div class="maintenance-timeline-item-stats-stat-value">{{ item.technician }}</div>
    </div>

    <div class="maintenance-timeline-item-stats-stat">
      <div class="maintenance-timeline-item-stats-stat-label">{{ t('downtime') }}</div>
      <div class="maintenance-timeline-item-stats-stat-value">{{ item.downtimeLabel }}</div>
    </div>
  </div>

  <!-- Right Section -->
  <div class="maintenance-timeline-item-status">
    <div class="maintenance-timeline-item-status-top">
      <div class="maintenance-timeline-item-status-label">{{ item.statusLabel }}</div>
      <div class="maintenance-timeline-item-status-date">{{ getStatusDate() }}</div>
    </div>
  
    <div class="maintenance-timeline-item-status-bottom">
      <div class="maintenance-timeline-item-status-badge" [ngClass]="item.isInHouse ? 'is-in-house' : 'is-out-sourced'">
        <span class="maintenance-timeline-item-status-badge-dot">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM7.33333 10H6V6H7.33333V10ZM7.33333 4.66667H6V3.33333H7.33333V4.66667Z" />
          </svg>
        </span>
        <span class="maintenance-timeline-item-status-badge-text">{{ item.isInHouse ? t('inHouse') : t('outSourced') }}</span>
      </div>
    </div>
  </div>
</div>